var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styled from 'styled-components';
import { HeadingAlign } from './Heading.enum';
import { handleHeadingSizeParams } from './Heading.helpers';
const BaseHeading = styled.h1 `
  display: block;
  font-weight: 600;
  padding: 0;
  margin: 0;
  text-align: ${({ align }) => align || HeadingAlign.LEFT};
  color: ${({ $color, theme }) => $color || theme.colors.text01};
  ${({ textSize }) => handleHeadingSizeParams(textSize)};
`;
const Heading = forwardRef((_a, ref) => {
    var { textSize, color, as, children } = _a, delegated = __rest(_a, ["textSize", "color", "as", "children"]);
    return (_jsx(BaseHeading, Object.assign({ ref: ref, "$color": color, as: as || 'h1', textSize: textSize }, delegated, { children: children }), void 0));
});
export default Heading;
//# sourceMappingURL=Heading.js.map